module.exports = __webpack_public_path__ + "img/challenge.5d485c72.svg";